/**
 * translations.js - Internationalization for eSIM Myanmar
 * Supports English (en) and Myanmar (mm)
 */

const translations = {
  en: {
    // Navigation
    home: 'Home',
    plans: 'Plans',
    features: 'Features',
    coverage: 'Coverage',
    support: 'Support',
    partners: 'Partners',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    dashboard: 'Dashboard',
    getStarted: 'Get Started',
    getESIM: 'Get eSIM',

    // Hero Section
    heroTitle: 'eSIM Myanmar Entertainment Server',
    heroSubtitle: 'Enterprise eSIM Management Platform serving 50M+ users across ASEAN with 5G, VoLTE, and seamless device transfer capabilities.',

    // Features
    esimTransfer: 'eSIM Transfer Android to Apple',
    esimTransferDesc: 'Seamlessly transfer your eSIM between Android and Apple devices with zero downtime.',
    network5G: '5G Network Support',
    network5GDesc: 'Experience blazing-fast 5G speeds across Myanmar and ASEAN region.',
    volte: 'VoLTE Enabled',
    volteDesc: 'Crystal-clear voice calls over LTE network with HD quality.',
    roaming: 'Advanced Roaming',
    roamingDesc: 'Stay connected worldwide with our advanced international roaming solutions.',
    multiDevice: 'Multi-Device Support',
    multiDeviceDesc: 'Connect smartphones, tablets, smartwatches, and iPads simultaneously.',
    instantActivation: 'Instant Activation',
    instantActivationDesc: 'Activate your eSIM in seconds with QR code scanning.',

    // Providers
    selectProvider: 'Select Your Provider',
    providerMPT: 'MPT',
    providerATOM: 'ATOM',
    providerU9: 'U9',
    providerMYTEL: 'MYTEL',

    // Registration Flow
    phoneNumber: 'Phone Number',
    enterPhone: 'Enter your phone number',
    validatePhone: 'Validate Phone Number',
    deviceInfo: 'Device Information',
    deviceType: 'Device Type',
    deviceModel: 'Device Model',
    osVersion: 'OS Version',
    checkCompatibility: 'Check Compatibility',
    payment: 'Payment',
    paymentAmount: 'Amount Due',
    verifyPayment: 'Verify Payment',
    verification: 'Verification',
    esimReady: 'eSIM Ready',
    scanQR: 'Scan QR Code',

    // Buttons
    submit: 'Submit',
    cancel: 'Cancel',
    continue: 'Continue',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',

    // Status
    loading: 'Loading...',
    success: 'Success',
    error: 'Error',
    pending: 'Pending',
    verified: 'Verified',
    failed: 'Failed',

    // Footer
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    refundPolicy: 'Refund Policy',
    cookiePolicy: 'Cookie Policy',

    // Seasonal
    seasonGreetings: 'Season Greetings',
    happyNewYear: 'Celebrating 4th Anniversary',
    countdownTo2026: 'Countdown to 2026',

    // Support
    faq: 'FAQ',
    helpCenter: 'Help Center',
    liveChat: 'Live Chat',
    emailSupport: 'Email Support',

    // Misc
    currency: 'MMK',
    esimPrice: '120,000 MMK',
    allRightsReserved: 'All rights reserved',

    // Campaign + CTAs
    getFreeEsim: 'Get Free eSIM',
    tapToInstall: 'Tap to Install',
    noQrActivation: 'No QR Activation',
    scanToActivate: 'Scan to Activate',
    iosInstallEsim: 'iOS Install eSIM',
    androidInstallEsim: 'Android Install eSIM',
    installEsimNow: 'Install eSIM Now',
    copyLpaString: 'Copy LPA String',
    copySuccess: 'Copied to clipboard',
    copyError: 'Copy failed',
    recommendedForYourDevice: 'Recommended for your device',
    campaignTitle: '4th Anniversary - Free eSIM | eSIM Myanmar',
    campaignSubtitle: 'Get your free eSIM instantly with no registration, no login, and no plan selection required.',
    backToOptions: 'Back to Options',
    call: 'Call'
  },

  mm: {
    // Navigation
    home: 'ပင်မစာမျက်နှာ',
    plans: 'အစီအစဉ်များ',
    features: 'အင်္ဂါရပ်များ',
    coverage: 'လွှမ်းခြုံမှု',
    support: 'အကူအညီ',
    partners: 'မိတ်ဖက်များ',
    login: 'ဝင်ရောက်ရန်',
    logout: 'ထွက်ရန်',
    register: 'စာရင်းသွင်းရန်',
    dashboard: 'ဒက်ရှ်ဘုတ်',
    getStarted: 'စတင်ရန်',
    getESIM: 'eSIM ရယူရန်',

    // Hero Section
    heroTitle: 'eSIM မြန်မာ ဖျော်ဖြေရေး ဆာဗာ',
    heroSubtitle: 'ASEAN တစ်ဝှမ်းရှိ သုံးစွဲသူ သန်း ၅၀ ကျော်ကို 5G၊ VoLTE နှင့် စက်ပစ္စည်းများအကြား လွှဲပြောင်းမှုဖြင့် ဝန်ဆောင်မှုပေးနေသော လုပ်ငန်းအဆင့် eSIM စီမံခန့်ခွဲမှု ပလက်ဖောင်း။',

    // Features
    esimTransfer: 'Android မှ Apple သို့ eSIM လွှဲပြောင်းခြင်း',
    esimTransferDesc: 'သင့် eSIM ကို Android နှင့် Apple စက်ပ��္စည်းများအကြား ချောမွေ့စွာ လွှဲပြောင်းပါ။',
    network5G: '5G ကွန်ရက် ပံ့ပိုးမှု',
    network5GDesc: 'မြန်မာနှင့် ASEAN ဒေသတစ်ဝှမ်း လျင်မြန်သော 5G အမြန်နှုန်းကို ခံစားပါ။',
    volte: 'VoLTE ဖွင့်ထားသည်',
    volteDesc: 'LTE ကွန်ရက်ပေါ်တွင် HD အရည်အသွေးဖြင့် ကြည်လင်သော အသံခေါ်ဆိုမှုများ။',
    roaming: 'အဆင့်မြင့် ရိုမင်း',
    roamingDesc: 'ကျွန်ုပ်တို့၏ အဆင့်မြင့် နိုင်ငံတကာ ရိုမင်း ဖြေရှင်းချက်များဖြင့် ကမ္ဘာတစ်ဝှမ်း ချိတ်ဆက်နေပါ။',
    multiDevice: 'စက်ပစ္စည်းများစွာ ပံ့ပိုးမှု',
    multiDeviceDesc: 'စမတ်ဖုန်းများ၊ တက်ဘလက်များ၊ စမတ်နာရီများနှင့် iPad များကို တစ်ပြိုင်နက် ချိတ်ဆက်ပါ။',
    instantActivation: 'ချက်ချင်း အသက်သွင်းခြင်း',
    instantActivationDesc: 'QR ကုဒ် စကင်ဖတ်ခြင်းဖြင့် သင့် eSIM ကို စက္ကန့်ပိုင်းအတွင်း အသက်သွင်းပါ။',

    // Providers
    selectProvider: 'သင့်ဝန်ဆောင်မှုပေးသူကို ရွေးချယ်ပါ',
    providerMPT: 'MPT',
    providerATOM: 'ATOM',
    providerU9: 'U9',
    providerMYTEL: 'MYTEL',

    // Registration Flow
    phoneNumber: 'ဖုန်းနံပါတ်',
    enterPhone: 'သင့်ဖုန်းနံပါတ်ကို ထည့်ပါ',
    validatePhone: 'ဖုန်းနံပါတ် အတည်ပြုရန်',
    deviceInfo: 'စက်ပစ္စည်း အချက်အလက်',
    deviceType: 'စက်ပစ္စည်း အမျိုးအစား',
    deviceModel: 'စက်ပစ္စည်း မော်ဒယ်',
    osVersion: 'OS ဗားရှင်း',
    checkCompatibility: 'လိုက်ဖက်မှု စစ်ဆေးရန်',
    payment: 'ငွေပေးချေမှု',
    paymentAmount: 'ပေးဆောင်���မည့် ပမာဏ',
    verifyPayment: 'ငွေပေးချေမှု အတည်ပြုရန်',
    verification: 'အတည်ပြုခြင်း',
    esimReady: 'eSIM အဆင်သင့်ဖြစ်ပါပြီ',
    scanQR: 'QR ကုဒ် စကင်ဖတ်ပါ',

    // Buttons
    submit: 'တင်သွင်းရန်',
    cancel: 'ပယ်ဖျက်ရန်',
    continue: 'ဆက်လက်ရန်',
    back: 'နောက်သို့',
    next: 'ရှေ့သို့',
    confirm: 'အတည်ပြုရန်',

    // Status
    loading: 'ဖွင့်နေသည်...',
    success: 'အောင်မြင်သည်',
    error: 'အမှား',
    pending: 'စောင့်ဆိုင်းနေသည်',
    verified: 'အတည်ပြုပြီး',
    failed: 'မအောင်မြင်ပါ',

    // Footer
    aboutUs: 'ကျွန်ုပ်တို့အကြောင်း',
    contactUs: 'ဆက်သွယ်ရန်',
    privacyPolicy: 'ကိုယ်ရေးအချက်အလက် မူဝါဒ',
    termsOfService: 'ဝန်ဆောင်မှု စည်းမျဉ်းများ',
    refundPolicy: 'ပြန်အမ်းငွေ မူဝါဒ',
    cookiePolicy: 'ကွတ်��ီး မူဝါဒ',

    // Seasonal
    seasonGreetings: 'ရာသီဥတု နှုတ်ခွန်းဆက်စကား',
    happyNewYear: 'နှစ်သစ်မင်္ဂလာ ၂၀၂၆',
    countdownTo2026: '၂၀၂၆ သို့ ရေတွက်ခြင်း',

    // Support
    faq: 'မေးလေ့ရှိသော မေးခွန်းများ',
    helpCenter: 'အကူအညီ စင်တာ',
    liveChat: 'တိုက်ရိုက် ချက်တင်',
    emailSupport: 'အီးမေးလ် အကူအညီ',

    // Misc
    currency: 'ကျပ်',
    esimPrice: '၁၂၀,၀၀၀ ကျပ်',
    allRightsReserved: 'မူပိုင်ခွင့် အားလုံး ရယူထားသည်',

    // Campaign + CTAs
    getFreeEsim: 'အခမဲ့ eSIM ရယူရန်',
    tapToInstall: 'တပ်ဆင်ရန် ထိပါ',
    noQrActivation: 'QR မလိုအပ်သော အသက်သွင်းမှု',
    scanToActivate: 'စကင်ဖတ်ပြီး အသက်သွင်းရန်',
    iosInstallEsim: 'iOS eSIM တပ်ဆင်ရန်',
    androidInstallEsim: 'Android eSIM တပ်ဆင်ရန်',
    installEsimNow: 'eSIM ကို ယခု တပ်ဆင်ရန်',
    copyLpaString: 'LPA စာသားကို ကူးယူရန်',
    copySuccess: 'ကော်ပီကူးပြီးပါပြီ',
    copyError: 'ကော်ပီမအောင်မြင်ပါ',
    recommendedForYourDevice: 'သင့်စက်ပစ္စည်းအတွက် အကြံပြုပြီး',
    campaignTitle: '၄ နှစ်ပြည့် အခမဲ့ eSIM | eSIM Myanmar',
    campaignSubtitle: 'အကောင့်မလို၊ စာရင်းသွင်းချင်စရာမလို၊ အစီအစဉ်ရွေးချယ်စရာမလိုဘဲ အခမဲ့ eSIM ကို ချက်ချင်းရယူနိုင်ပါသည်။',
    backToOptions: 'ရွေးချယ်မှုများသို့ ပြန်သွားရန်',
    call: 'ခေါ်ဆိုရန်'
  }
};

export default translations;
